import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ClienteModel} from '../content/pages/components/models/cliente.model';

@Injectable({ providedIn: 'root' })
export class ClienteService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/cliente';
  }

  displayAutoComplete = (value) => {
    return value ? `${value.id} - ${value.fantasia ? value.fantasia : value.nome}` : '';
  }

  pesquisarClienteAutoComplete(valor) {
    const filtro = (valor.cliente  ? valor.cliente : valor);
    return this.get('/pesquisarLimitado', {
      dados: {
        nome: filtro
      },
      exibirLoading: false
    });
  }

  pesquisarCliente(campoOrdenacao,
    indicePrimeiroRegistroPagina,
    tamanhoPagina,
    tipoOrdenacao,
    nome) {
    return this.get<any>('/pesquisar', {
      dados: {
        campoOrdenacao: campoOrdenacao,
        indicePrimeiroRegistroPagina: indicePrimeiroRegistroPagina,
        tamanhoPagina: tamanhoPagina,
        tipoOrdenacao: tipoOrdenacao,
        nome: nome
      },
      exibirLoading: false
    });
  }

  consultarCliente(id) {
    return this.get('/consultar', {
      dados: { id: id }
    });
  }

  consultarListaIds(ids) {
    return this.post(`/pesquisarPorListaIds`, {
      dados: ids,
      exibirLoading: true
    });
  }


  importarLocalizacaoERP(atualizarTodos: boolean) {
    return this.post<{ valido: boolean }>('/importarLocalizacaoERP', {
      dados: {
        atualizarTodos: atualizarTodos
      }, enviarComoQueryString: true
    });
  }

  gerarLocalizacaoClientePorCep(atualizarTodos: boolean) {
    return this.post<{ valido: boolean }>('/gerarLocalizacaoClientePorCep', {
      dados: {
        atualizarTodos: atualizarTodos
      }, enviarComoQueryString: true
    });
  }

  gerarLocalizacaoEnderecosEntrega(substituirLocalizacoesExistentesNoRoteirizador: boolean, apenasComprasUltimosSeisMeses: boolean) {
    return this.get<{ valido: boolean }>('/gerarLocalizacaoEnderecosEntrega', {
		dados: {
			substituirLocalizacoesExistentesNoRoteirizador,
			apenasComprasUltimosSeisMeses
		  }

	});
  }

  importarDasEntregasEfetuadas(filtro: any) {
    return this.post<{ valido: boolean }>('/importarDasEntregasEfetuadas', {
      dados: filtro,
	  enviarComoQueryString:true
    });
  }





  gerarLocalizacaoPorCEPClientesComPedidos() {
    return this.get<{ valido: boolean }>('/gerarLocalizacaoPorCEPClientesComPedidos');
  }

  importarLocalizacaoClientesERPSexagesimal(atualizarTodosClientes: boolean) {
    return this.get<{ valido: boolean }>('/importarLocalizacaoClientesERPSexagesimal', {
      dados: {
        substituirLocalizacoesExistentesNoRoteirizador: atualizarTodosClientes
      }
    });
  }

  importarLocalizacaoClientesERP(atualizarTodosClientes: boolean) {
    return this.get<{ valido: boolean }>('/importarLocalizacaoClientesERP', {
      dados: {
        substituirLocalizacoesExistentesNoRoteirizador: atualizarTodosClientes
      }
    });
  }

  gerarLocalizacaoClientesPorCEP(substituirLocalizacoesExistentesNoRoteirizador: boolean, apenasComprasUltimosSeisMeses: boolean) {
    return this.get<{ valido: boolean }>('/gerarLocalizacaoClientesPorCEP', {
      dados: {
        substituirLocalizacoesExistentesNoRoteirizador,
        apenasComprasUltimosSeisMeses
      }
    });
  }

  getCoordenadasGeograficasByEndereco(clienteCoordenada) {
    return this.get<any>('/geoCodificarPeloEndereco', { dados: clienteCoordenada });
  }

	pesquisarClienteAutoCompleteIdFantasia(valor) {
		if (valor === undefined || valor === null) {
			return of([]);
		}
		return this.get<any[]>('/pesquisarLimitadoIdFantasia', {
			dados: {
				value: valor
			},
			exibirLoading: false
		});
	}

	pesquisarLimitado(valor: string): Observable<string[]> {
		return this.get<any[]>('/pesquisarLimitadoMultiploCodCli', {
			dados: {
				codCli: valor
			},
			exibirLoading: false
		});
	}

	// Não retirar pode parecer que não tem uso, porém ele é passado como string em um component
	pesquisarClienteSimplificadoByValue(valor: string): Observable<string[]> {
		return this.get<any[]>('/pesquisarClienteSimplificadoByValue', {
			dados: {
				valor
			},
			exibirLoading: false
		});
	}

	listarComContato() {
		return this.get('/listarComContato');
	}

  pesquisarClienteComId(campoOrdenacao: string, indicePrimeiroRegistroPagina: number, tamanhoPagina: number, tipoOrdenacao: string, valor: string) {
    const isNumeric = !isNaN(Number(valor));
    if (isNumeric) {
        return this.get<any>('/pesquisar', {
            dados: {
                campoOrdenacao: campoOrdenacao,
                indicePrimeiroRegistroPagina: indicePrimeiroRegistroPagina,
                tamanhoPagina: tamanhoPagina,
                tipoOrdenacao: tipoOrdenacao,
                codigo: valor
            },
            exibirLoading: false
        });
    } else {

        return this.get<any>('/pesquisar', {
            dados: {
                campoOrdenacao: campoOrdenacao,
                indicePrimeiroRegistroPagina: indicePrimeiroRegistroPagina,
                tamanhoPagina: tamanhoPagina,
                tipoOrdenacao: tipoOrdenacao,
                nome: valor
            },
            exibirLoading: false
        });
    }
}
	atualizar(cliente) {
		return this.post<ClienteModel>('/atualizar', {dados: cliente});
	}

	consultarClienteEnderecoEntrega(clienteId: string, clienteIdEnderecoEntrega: string) {
		return this.get<any>('/consultarClienteEnderecoEntrega', {
			dados: {
				idCliente: clienteId, idEnderecoEntrega: clienteIdEnderecoEntrega
			},
			exibirLoading: true,
		});
	}

}
